(function () {
    const REFUNDED_STATUS = "Refunded";
    const ORDER_DATE_SURPASSED_REFUNDABLE_DATE_EXCEPTION = "OrderDateSurpassedRefundableDateException";

    class OrderRefundModalController {
        constructor(
            $scope,
            $uibModalInstance,
            LocalisationService,
            OrderService,
            ErrorService,
            notify,
            orderGuid,
            callback
        ) {
            this.$scope = $scope;
            this._modalInstance = $uibModalInstance;
            this._orderService = OrderService;
            this._errorService = ErrorService;
            this._notifier = notify;
            this.orderGuid = orderGuid;
            this.callback = callback;

            this.$scope.refundReasonOptions = [
                "Choose One",
                "Food was not up to standard",
                "Order was out of delivery zone",
                "Order was late",
                "Order was cancelled",
                "Order failed",
                "No delivery time",
                "Incorrect amount",
                "Store closed",
                "Other",
            ];

            this.$scope.otherOption = this.$scope.refundReasonOptions[9];
            this.$scope.chooseOption = this.$scope.refundReasonOptions[0];
            this.$scope.isLoading = false;
            this.$scope.dateTimeFormat = LocalisationService.Configuration.DateTimeFilterFormat;

            this.$scope.reasonChanged = this.reasonChanged.bind(this);
            this.$scope.close = this.close.bind(this);
            this.$scope.refundOrder = this.refundOrder.bind(this);
            this.$scope.hasPayments = this.hasPayments.bind(this);
            this.$scope.cardPaymentRequiresRefund = false;
            this.$scope.voucherRequiresRefund = false;

            void this.initialise();
        }

        async initialise() {
            await this.loadOrder();
            this.$scope.refundReason = this.$scope.refundReasonOptions[0];
            this.$scope.$applyAsync();
            this.closeIfNothingToRefund();
        }

        closeIfNothingToRefund() {
            if (!this.$scope.order) {
                return;
            }
            const hasRefundablePayment =
                this.fetchCardPaymentId() !== null ||
                this.fetchVoucherId() !== null;
            if (hasRefundablePayment) {
                return;
            }
            this._errorService.showError("This order has already been refunded, or there is no payment or voucher to refund.", null);
            this.close();
        }

        reasonChanged(reason) {
            this.$scope.refundReason = reason;
        }

        async loadOrder() {
            this.$scope.isLoading = true;
            try {
                const result = await this._orderService.getOrder(this.orderGuid);
                this.$scope.order = new Dashboard.Models.Order(result.data.Order);
                this.$scope.customer = result.data.Customer;
                this.$scope.hasVoucher = !!this.$scope.order.Voucher;
                if (this.fetchCardPaymentId() !== null) {
                    await this.fetchPaymentDetails();
                }
                this.$scope.voucherRequiresRefund = !!this.$scope.order.VoucherIsReversible;
            } catch (error) {
                this._errorService.showError("An error occurred when loading the order.", null);
            } finally {
                this.$scope.isLoading = false;
                this.$scope.$applyAsync();
            }
        }

        async fetchPaymentDetails() {
            const terminals = await this._orderService.getOrderTerminals(this.$scope.order.OrderGuid);
            this.$scope.terminals = terminals.data;
            this.$scope.terminalMismatch = this.$scope.terminals.OrderTerminalId !== this.$scope.terminals.StoreTerminalId;
            this.$scope.cardPaymentRequiresRefund = this.$scope.terminals.RefundStatus !== REFUNDED_STATUS;
        }

        close() {
            this._modalInstance.close();
        }

        async refundOrder() {
            if (!this.$scope.refundReason ||
                this.$scope.refundReason === this.$scope.chooseOption) {
                this._errorService.showError("Please provide a reason for refund.", null);
                return;
            }

            const cardPaymentId = this.fetchCardPaymentId();
            const voucherId = this.fetchVoucherId();
            const reason = this.fetchRefundReason();

            if (!reason) {
                this._errorService.showError("Must select a refund reason.", null);
                return;
            }

            try {
                await this._orderService.refundOrder({
                    OrderId: this.$scope.order.Id,
                    CardPaymentId: cardPaymentId,
                    VoucherId: voucherId,
                    Reason: reason
                });
                this.close();
                if (this.callback) {
                    this.callback();
                }
                this._notifier.success("A refund has been initiated");
            } catch (error) {
                if (error && error.data) {
                    if (error.data.Type && error.data.Type === ORDER_DATE_SURPASSED_REFUNDABLE_DATE_EXCEPTION) {
                        this._errorService.showError("The payment is too old to refund. The store can send a written request to Yumbi to have the refund done manually.", null);
                        return;
                    }
                    this._errorService.showError("An error occurred when attempting to refund the payment", null);
                }
            }
        }

        fetchRefundReason() {
            if (this.$scope.refundReason !== this.$scope.otherOption) {
                return this.$scope.refundReason;
            }
            return ($("#refundReasonInput").val() || "").trim();
        }

        fetchVoucherId() {
            return this.$scope.order.Voucher && this.$scope.order.VoucherIsReversible
                ? this.$scope.order.Voucher.Id
                : null;
        }

        fetchCardPaymentId() {
            return this.$scope.order.CreditCardPayment?.CardPaymentStateId === Dashboard.CreditCardPaymentStates.Paid
                ? this.$scope.order.CreditCardPayment.Id
                : null;
        }

        hasPayments() {
            if (!this.$scope.order) {
                return false;
            }

            return this.$scope.order.CreditCardPayment
                || this.$scope.order.Voucher;
        }
    }

    angular
        .module("dashboard")
        .controller("OrderRefundModalController", [
            "$scope",
            "$uibModalInstance",
            "LocalisationService",
            "OrderService",
            "ErrorService",
            "notify",
            "orderGuid",
            "callback",
            OrderRefundModalController
        ]);
})();
